import { service }       from '../../../../helpers/http'
import { getLocalToken } from '../../../../modules/auth/storage'
import * as types        from './mutation-types'

const MODULE = 'domainIntegrationDatabricksImport'

export const ActionPostDispatch = ({ commit }, payload) => {
    commit(types.SET_IS_DISPATCHING, true)
    return service({
        module: MODULE,
        action: 'postDispatch',
        payload: payload,
    }).finally(() => {
        commit(types.SET_IS_DISPATCHING, false)
    })
}

export const ActionGetCurrentBatch = ({ commit }, payload) => {
    return service({
        module: MODULE,
        action: 'getCurrentBatch',
        payload: payload,
    }).then((response) => {
        const batch = (response && response.data) ? response.data : null
        commit(types.SET_CURRENT_BATCH, batch)
        return batch
    })
}

export const ActionGetHistory = ({ commit }, payload) => {
    return service({
        module: MODULE,
        action: 'getHistory',
        payload: payload,
    }).then((response) => {
        const list = (response && Array.isArray(response.data)) ? response.data : []
        commit(types.SET_HISTORY, list)
        return list
    })
}

export const ActionCancelBatch = ({ commit }) => {
    commit(types.SET_IS_CANCELLING, true)
    return service({
        module: MODULE,
        action: 'cancelBatch',
        payload: {},
    }).finally(() => {
        commit(types.SET_IS_CANCELLING, false)
    })
}

export const ActionSetIsPolling = ({ commit }, value) => {
    commit(types.SET_IS_POLLING, value)
}

export const ActionSetCurrentBatch = ({ commit }, batch) => {
    commit(types.SET_CURRENT_BATCH, batch)
}

export const ActionGetBatchRuns = (_, payload) => {
    return service({
        module: MODULE,
        action: 'getBatchRuns',
        payload: payload,
    }).then((response) => {
        return (response && Array.isArray(response.data)) ? response.data : []
    })
}

export const ActionGetBatchErrors = (_, payload) => {
    return service({
        module: MODULE,
        action: 'getBatchErrors',
        payload: payload,
    }).then((response) => {
        return (response && response.data) ? response.data : { total: 0, items: [] }
    })
}

export const ActionGetSchedule = (_, payload) => {
    return service({
        module: MODULE,
        action: 'getSchedule',
        payload: payload || {},
    }).then((response) => {
        // Backend responde { data: { ... } } ou { data: null } se ainda nao
        // configurado — devolvemos null nesse caso para o componente saber
        // que precisa pre-popular com defaults.
        return (response && response.data) ? response.data : null
    })
}

export const ActionSaveSchedule = (_, payload) => {
    return service({
        module: MODULE,
        action: 'saveSchedule',
        payload: payload,
    }).then((response) => {
        return (response && response.data) ? response.data : null
    })
}

export const ActionGetEmailSettings = (_, payload) => {
    return service({
        module: MODULE,
        action: 'getEmailSettings',
        payload: payload || {},
    }).then((response) => {
        return (response && response.data) ? response.data : null
    })
}

export const ActionSaveEmailSettings = (_, payload) => {
    return service({
        module: MODULE,
        action: 'saveEmailSettings',
        payload: payload,
    }).then((response) => {
        return (response && response.data) ? response.data : null
    })
}

/**
 * Download do CSV de registros ignorados. Nao usa vue-resource porque o
 * endpoint retorna blob streaming — fetch nativo lida bem e mantem o
 * download incremental (browser pode comecar a salvar antes do servidor
 * fechar a resposta). JWT vai no header Authorization, igual ao restante.
 */
export const ActionDownloadSkipsCsv = (_, payload) => {
    const mergeDate = payload && payload.merge_date
    if (!mergeDate) {
        return Promise.reject(new Error('merge_date obrigatorio'))
    }

    const root = process.env.VUE_APP_ROOT_API || ''
    const sep = root.endsWith('/') ? '' : '/'
    const url = `${root}${sep}databricks-import-runs/skips-csv?merge_date=${encodeURIComponent(mergeDate)}`

    const token = getLocalToken()

    return fetch(url, {
        method: 'GET',
        headers: {
            Authorization: token ? `Bearer ${token}` : '',
            Accept:        'text/csv',
        },
    }).then((res) => {
        if (!res.ok) {
            throw new Error(`HTTP ${res.status}`)
        }
        return res.blob()
    }).then((blob) => {
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = `registros_ignorados_${mergeDate}.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()
        // Libera memoria do blob; o download ja foi disparado.
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
    })
}
